/* Collection page — scent-family filter chips (port of the original o9 "sk" filter).
   <brogi-collection-filter data-grid="ID" data-active-class="…" data-inactive-class="…">
     <button data-family="" …>All</button>
     <button data-family="woody-1" data-handles=",first-love,not-usual," …>woody</button>
   Items in the grid: [data-product-handle]. Clicking the active chip again resets to "All" (like the original). */
(function () {
  if (customElements.get('brogi-collection-filter')) return;
  customElements.define('brogi-collection-filter', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.active = '';
      this.activeCls = (this.dataset.activeClass || '').split(/\s+/).filter(Boolean);
      this.inactiveCls = (this.dataset.inactiveClass || '').split(/\s+/).filter(Boolean);
      this.buttons = Array.from(this.querySelectorAll('button[data-family]'));
      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const key = btn.dataset.family || '';
          this.apply(key && key === this.active ? '' : key);
        });
      });
    }
    apply(key) {
      this.active = key;
      const current = this.buttons.find((b) => (b.dataset.family || '') === key);
      const handles = current && key ? current.dataset.handles || '' : null;
      this.buttons.forEach((b) => {
        const on = (b.dataset.family || '') === key;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        (on ? this.inactiveCls : this.activeCls).forEach((c) => b.classList.remove(c));
        (on ? this.activeCls : this.inactiveCls).forEach((c) => b.classList.add(c));
      });
      const grid = document.getElementById(this.dataset.grid);
      if (!grid) return;
      grid.querySelectorAll('[data-product-handle]').forEach((item) => {
        const show = handles === null || handles.indexOf(',' + item.dataset.productHandle + ',') > -1;
        item.style.display = show ? '' : 'none';
        if (show) {
          item.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach((el) => el.classList.add('is-revealed'));
        }
      });
    }
  });
})();
